import { Col, Form, Input, Row, Statistic } from 'antd'
import AccountsCascader from '../../../../elements/Cascader/AccountsCascader'
import CentersCascader from '../../../../elements/Cascader/CentersCascader'
import useFetchSelectUrl from '../../../../elements/Hooks/useFetchSelectUrl'
import useFetchURL from '../../../../elements/Hooks/useFetchURL'
import { get, isEmpty } from 'lodash'
import { defaultFormItemLayout, fullWidthFormItemLayout, rules } from '../../../../modules/FormItems'
import { findCascadersParents, strVal } from '../../../../modules/Utils'
import React from 'react'

function DeliveryOrderLinesForm (props) {
  const { line, list, delivery, accounts, centers } = props
  const { getFieldDecorator } = props.form
  const Max = Math.max(...list.map((o) => o.no), 0) + 1

  const budgetKey = get(delivery, 'budget._id', '').replace('budgets/', '')
  const [BudgetLinesSelect] = useFetchSelectUrl(
    {
      name: 'budgetsLines',
      url: `budgets/${budgetKey}/lines`,
      cache: false,
      forceFetch: true,
    },
    [budgetKey],
  )
  const { data: budgetsLines } = useFetchURL(
    `foxxapi/budgets/${budgetKey}/lines`,
    [budgetKey],
    isEmpty(budgetKey),
    undefined,
    true,
  )

  return (
    <Form>
      <Row>
        <Col span={6}>
          <Statistic title="Unit(s)" value={get(line, 'unit')}/>
        </Col>
        <Col span={6}>
          <Statistic title="purchased" value={get(line, 'purchased')}/>
        </Col>
        <Col span={6}>
          <Statistic
            title="In Transit"
            value={get(line, 'package', [])
              .filter((p) => ['Delivered', 'Confirmed'].includes(p.status))
              .map((p) => p.unit)
              .reduce((acc, v) => v + acc, 0)}
          />
        </Col>
        <Col span={6}>
          <Statistic title="Requisitioned" value={get(line, 'requisitioned')}/>
        </Col>
      </Row>
      <Row>
        <Col span={6}>
          <Statistic title="Ready" value={get(line, 'ready')}/>
        </Col>
        <Col span={6}>
          <Statistic title="Delivered" value={get(line, 'delivered')}/>
        </Col>
      </Row>

      <Row style={{ marginTop: '50px' }}>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="No">
            {getFieldDecorator('no', {
              initialValue: get(line, 'no') || Max,
              rules: rules.select,
            })(<Input placeholder={'No'}/>)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        {/*<Col span={12}>*/}
        {/*  <Form.Item {...defaultFormItemLayout} label="Unit(s)">*/}
        {/*    {getFieldDecorator('unit', {*/}
        {/*      initialValue: get(line, 'unit'),*/}
        {/*      rules: rules.select,*/}
        {/*    })(<Input disabled={true} placeholder={'unit'} />)}*/}
        {/*  </Form.Item>*/}
        {/*</Col>*/}
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Name">
            {getFieldDecorator('name', {
              initialValue: get(line, 'name'),
              rules: rules.select,
            })(<Input placeholder={'name'}/>)}
          </Form.Item>
        </Col>
        {/*<Col span={12}>*/}
        {/*  <Form.Item {...defaultFormItemLayout} label="Purchased">*/}
        {/*    {getFieldDecorator('purchased', {*/}
        {/*      initialValue: get(line, 'purchased'),*/}
        {/*      rules: rules.select,*/}
        {/*    })(<Input disabled={true} placeholder={'purchased'} />)}*/}
        {/*  </Form.Item>*/}
        {/*</Col>*/}
        {/*<Col span={12}>*/}
        {/*  <Form.Item {...defaultFormItemLayout} label="In Transit">*/}
        {/*    {getFieldDecorator('package', {*/}
        {/*      initialValue: get(line, 'package', [])*/}
        {/*        .filter(p => ['Delivered', 'Confirmed'].includes(p.status))*/}
        {/*        .map(p => p.unit)*/}
        {/*        .reduce((acc, v) => v + acc, 0),*/}
        {/*      rules: rules.select,*/}
        {/*    })(<Input disabled={true} placeholder={'purchased'} />)}*/}
        {/*  </Form.Item>*/}
        {/*</Col>*/}
        {/*<Col span={12}>*/}
        {/*  <Form.Item {...defaultFormItemLayout} label="Requisitioned">*/}
        {/*    {getFieldDecorator('requisitioned', {*/}
        {/*      initialValue: get(line, 'requisitioned'),*/}
        {/*      rules: rules.select,*/}
        {/*    })(<Input disabled={true} placeholder={'requisitioned'} />)}*/}
        {/*  </Form.Item>*/}
        {/*</Col>*/}
        {/*<Col span={12}>*/}
        {/*  <Form.Item {...defaultFormItemLayout} label="Ready">*/}
        {/*    {getFieldDecorator('ready', {*/}
        {/*      initialValue: get(line, 'ready'),*/}
        {/*      rules: rules.select,*/}
        {/*    })(<Input disabled={true} placeholder={'ready'} />)}*/}
        {/*  </Form.Item>*/}
        {/*</Col>*/}
        {/*<Col span={12}>*/}
        {/*  <Form.Item {...defaultFormItemLayout} label="Delivered">*/}
        {/*    {getFieldDecorator('delivered', {*/}
        {/*      initialValue: get(line, 'delivered'),*/}
        {/*      rules: rules.select,*/}
        {/*    })(<Input disabled={true} placeholder={'delivered'} />)}*/}
        {/*  </Form.Item>*/}
        {/*</Col>*/}
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Budget Line">
            {getFieldDecorator('budgetLine._id', {
              initialValue:
                get(line, 'budgetLine._id') ||
                get(
                  budgetsLines.find((b) => b.name === 'Freight'),
                  '_id',
                ),
            })(<BudgetLinesSelect keyAtr={'_id'} valueAtr={'name'} placeholder={'budgetLine'}/>)}
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item {...fullWidthFormItemLayout} label="Account">
            {getFieldDecorator('account._id', {
              initialValue: findCascadersParents(accounts, strVal(line, 'account._id')),
              rules: rules.select,
            })(<AccountsCascader placeholder={'account'}/>)}
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item {...fullWidthFormItemLayout} label="Center">
            {getFieldDecorator('center._id', {
              initialValue: findCascadersParents(centers, strVal(line, 'center._id')),
              rules: rules.select,
            })(<CentersCascader placeholder={'Select Center'}/>)}
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}

DeliveryOrderLinesForm.propTypes = {}
DeliveryOrderLinesForm.defaultProps = {}

export default Form.create()(DeliveryOrderLinesForm)
